import { createSelector } from '@ngrx/store';

import * as fromRequest from '../reducers/request.reducers'
import * as fromRoot from '../reducers'

export const selectRequestHistory = createSelector(fromRoot.selectRequestState, fromRequest.getRequestHistory);
export const selectRequestFiles = createSelector(fromRoot.selectRequestState, fromRequest.getRequestFiles);
export const selectRequestCharge = createSelector(fromRoot.selectRequestState, fromRequest.getRequestCharge);
export const selectRequestFeedbacks = createSelector(fromRoot.selectRequestState, fromRequest.getRequestFeedbacks);
export const selectFeedbacksTotal = createSelector(fromRoot.selectRequestState, fromRequest.selectFeedbacksTotal);



// WEBPACK FOOTER //
// ./src/app/core/store/selectors/request.selectors.ts